import React from 'react';
import MediaQuery from 'react-responsive';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';

export const renderLinks = links => (
  links.map((link, i) => (
    <MediaQuery maxWidth={link.maxWidth} minWidth={link.minWidth} key={`link-${i}`}>
      <LinkFreeStanding
        className={link.class}
        dark={link.colorScheme.indexOf('db') === 0}
        size={link.size}
        icon={link.icon}
        onClick={link.onClick}  
        withBouncing
      >
        {link.text}
      </LinkFreeStanding>
    </MediaQuery>
  ))
);

export const renderButtons = buttons => (
  buttons.map((button, i) => (
    <MediaQuery maxWidth={button.maxWidth} minWidth={button.minWidth} key={`button-${i}`}>
      <Button
        classes={button.class}
        onClick={button.onClick}
      >
        {button.text}
      </Button>
    </MediaQuery>
  ))
);


// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/common.js